import React from "react";
import { useState } from "react";
import { useParallax } from "react-scroll-parallax";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import animationData from "../../MyAnimations/Animation - 1743874723452.json";
const imageVariant = {
  hidden: { x: "-100vw", opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 1.5, ease: "easeOut" } },
};

const textVariant = {
  hidden: { x: 50, opacity: 0 },
  visible: (delay) => ({
    x: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut", delay },
  }),
};

const workList = [
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg",
    title: "Supervised Learning",
    desc: "Implementing classification and regression models using decision trees, SVMs, and neural networks for predictive analytics.",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
    title: "Deep Learning",
    desc: "Building and optimizing complex neural network architectures for computer vision and natural language processing tasks.",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/a/ae/Keras_logo.svg",
    title: "Reinforcement Learning",
    desc: "Developing agents that learn optimal policies through interaction with environments using Q-learning and policy gradients.",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/8/84/Matplotlib_icon.svg",
    title: "Data Visualization",
    desc: "Creating insightful visualizations to communicate complex patterns and relationships in high-dimensional datasets.",
  },
];

const techLogos = [
  "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg",
  "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg",
  "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
  "https://upload.wikimedia.org/wikipedia/commons/3/31/NumPy_logo_2020.svg",
  "https://pandas.pydata.org/static/img/pandas_white.svg",
  
  // "https://upload.wikimedia.org/wikipedia/commons/a/ae/Keras_logo.svg",
  // "https://upload.wikimedia.org/commons/8/84/Matplotlib_icon.svg",
  // "https://upload.wikimedia.org/wikipedia/commons/3/31/NumPy_logo_2020.svg",
  // "https://upload.wikimedia.org/wikipedia/commons/e/ed/Pandas_logo.svg",
  // "https://upload.wikimedia.org/wikipedia/commons/0/01/Created_with_Matplotlib-logo.svg",
  // "https://upload.wikimedia.org/wikipedia/commons/8/88/SpaCy_logo.svg",
  // "https://upload.wikimedia.org/wikipedia/commons/0/0a/PyTorch_logo.svg",
  // "https://upload.wikimedia.org/wikipedia/commons/8/8a/OpenCV_Logo_with_text.png",
];

const MachineLearningSection
 = () => {
  const parallax = useParallax({ translateY: [-24, 24], rootMargin: 0 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);


  return (
    <section className="work-area pt-110 bg-[#292930] text-white" style={{paddingTop : isMobile && 50, paddingBottom : isMobile && 50}}>
      <div className="container">
        <div className="row align-items-center">
          <motion.div
            className="image-container"
            variants={imageVariant}
            initial="hidden"
            animate="visible"
            style={{ marginTop: "-50px" }}
          >
            <Lottie animationData={animationData} loop={true} style={{ width: !isMobile ? "90%" : "100%", marginTop : !isMobile ? "100px" : "30px", marginLeft : !isMobile ? "50px" : "0px"}} />
            </motion.div>

          <div className="col-lg-6">
            <div className="work-content">
              <div className="section-title title-style-two white-title">
                <span className="sub-title">Technologies</span>
                <h1 style={{fontSize : isMobile ? "30px" : "40px", color : "white"}}>Machine Learning</h1>
              </div>

              <motion.div 
                className="tech-icons flex flex-wrap justify-center lg:justify-start mb-8"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ staggerChildren: 0.1, delayChildren: 0.3 }}
              >
                {techLogos.map((src, index) => (
                  <motion.div
                    key={index}
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: index * 0.05 }}
                  >
                    <img 
                      src={src} 
                      alt="ML Technology Logo" 
                      className="inline-block m-2 w-12 h-12 transition-transform duration-300 hover:scale-110" 
                    />
                  </motion.div>
                ))}
              </motion.div>

              <div className="work-list">
                <ul className="list-wrap">
                  {workList.map((item, index) => (
                    <motion.li
                      key={index}
                      className="p-1 mb-2 bg-[#33333b] rounded-lg border-l-4 border-blue-500 hover:bg-[#3a3a42] transition-colors duration-200"
                      variants={textVariant}
                      custom={0.2 + index * 0.2}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      style={{padding: "0px", margin: "0px"}}
                    >
                      <div className="content">
                        <p className="text-white text-sm w-full" style={{width: "100%", padding: "0px", fontSize: "1rem"}}>{item.desc}</p>
                      </div>
                    </motion.li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="work-shape-wrap">
        <img src="/img/images/work_shape01.png" alt="" />
        <img src="/img/images/work_shape02.png" alt="" ref={parallax.ref} />
        <img src="/img/images/work_shape03.png" alt="" />
        <img src="/img/images/work_shape04.png" alt="" />
        <img src="/img/images/work_shape05.png" alt="" />
      </div>
    </section>
  );
};

export default MachineLearningSection;